import { IMG } from "./site";

// Unique local copy for each city is added during the SEO content phase.
export const LOCATIONS = [
  {
    slug: "huntersville-nc",
    name: "Huntersville",
    county: "Mecklenburg County",
    image: IMG.living,
    imageAlt: "Living room with stone fireplace and wood-look luxury vinyl plank, the style popular in Huntersville homes",
    map: { x: 343, y: 253 },
    intro: "Huntersville sits on the southeast side of Lake Norman, just minutes from our Cornelius location. We help Huntersville homeowners refresh single rooms and whole homes, and supply builders and remodelers working across the town's newer neighborhoods.",
    contractorIntro: "Builders, remodelers and property managers working in Huntersville can source luxury vinyl plank at wholesale pricing with jobsite delivery coordinated from nearby Cornelius.",
    nearby: ["cornelius-nc", "denver-nc"],
  },
  {
    slug: "cornelius-nc",
    name: "Cornelius",
    county: "Mecklenburg County",
    image: IMG.oak,
    imageAlt: "Sunlit lake-area living room with rich wood-look LVP flooring and tall windows",
    map: { x: 324, y: 187 },
    intro: "Cornelius is home base. Our location on Bailey Road puts us close to lakefront homes, townhome communities and remodel projects throughout town, so estimates, samples and installs are easy to schedule.",
    contractorIntro: "Contractors working in Cornelius can pick up from or have orders coordinated straight from our Bailey Road location, with volume pricing for new construction, renovations and multi-unit work.",
    nearby: ["huntersville-nc", "denver-nc"],
  },
  {
    slug: "denver-nc",
    name: "Denver",
    county: "Lincoln County",
    image: IMG.bright,
    imageAlt: "Bright open-plan home with light luxury vinyl plank flooring",
    map: { x: 162, y: 141 },
    intro: "Denver lies on the west shore of Lake Norman in Lincoln County. We serve Denver homeowners with in-home estimates, flooring selection and professional installation for lake homes, new builds and remodels.",
    contractorIntro: "Builders and contractors across Denver's growing west-shore communities can buy flooring wholesale and coordinate delivery to active jobsites.",
    nearby: ["sherrills-ford-nc", "iron-station-nc"],
  },
  {
    slug: "sherrills-ford-nc",
    name: "Sherrills Ford",
    county: "Catawba County",
    image: IMG.oak2,
    imageAlt: "Modern living room with mid-tone luxury vinyl plank flooring",
    map: { x: 200, y: 56 },
    intro: "Sherrills Ford sits along the northwest shore of Lake Norman in Catawba County. Homeowners here can get flooring and installation from one local team without big-box retail pricing.",
    contractorIntro: "Contractors building or renovating around Sherrills Ford can order flooring at wholesale pricing with jobsite delivery coordinated for each project.",
    nearby: ["denver-nc", "cornelius-nc"],
  },
  {
    slug: "iron-station-nc",
    name: "Iron Station",
    county: "Lincoln County",
    image: IMG.living2,
    imageAlt: "Renovated living room with durable wood-look LVP flooring",
    map: { x: 48, y: 225 },
    intro: "Iron Station is a quieter Lincoln County community west of Lake Norman. We bring wholesale flooring, estimates and installation to Iron Station homes, farmhouses and rental properties.",
    contractorIntro: "Builders and investors working in Iron Station can source flooring wholesale and have materials coordinated for delivery to their projects.",
    nearby: ["denver-nc", "huntersville-nc"],
  },
];

export const locationBySlug = (slug) => LOCATIONS.find((l) => l.slug === slug);
